export default __webpack_public_path__ + "static/is-55414300b3c0d3131b8bcbe7d17fcfd1.svg";